import sha256 from "crypto-js/sha256";

const convertPhoneToPayload = (phone) => {
  if (!phone) return "";
  const cleanedPhone = phone.replace(/[^\d+]/g, "").replace("+55", "");

  return cleanedPhone;
};

const convertPhoneToGTM = (phone) => {
  if (!phone) return "";
  const cleanedPhone = phone.replace(/[^\d+]/g, "");

  return cleanedPhone;
};

const convertPhoneToHash = (phone) => {
  if (!phone) return "";
  const cleanedPhone = phone.replace(/[^\d+]/g, "");
  const hashedPhone = sha256(cleanedPhone).toString();

  return hashedPhone;
};

export { convertPhoneToPayload, convertPhoneToGTM, convertPhoneToHash };
